import { request } from "./request";

let modes = [
	{
		type: "mode",
		on: false,
		id: "darkpage_setting"
	},
	{
		type: "mode",
		on: false,
		id: "banner_setting",
		banner: {
			en: ""
		}
	}
];
// default modes

export const checkModes = async () => {
	try {
		const srcModes = await request({
			reqId: "644bff17-8cd7-46ea-b103-8d98ac019eaa",
			datatype: "mode"
		});
		modes.forEach((localMode, index) => {
			const srcSetting = srcModes.find(item => item.id === localMode.id);
			if (srcSetting) {
				modes[index] = srcSetting;
			}
		});
		// if a setting found in source JSON,
		// update the default obj with it

		return modes;
	} catch (err) {
		console.error("Error checking site mode; returning defaults. Error:", err);
		return defaultModes;
	}
};

export const toggleMode = (id, mode) => {
	return new Promise(async (resolve, reject) => {
		try {
			const response = await request({
				reqId: "0a781917-4959-4da0-901e-c555078aad80",
				datatype: "mode",
				id: id,
				names: {
					"#on": "on"
				},
				values: {
					":value": mode
				},
				update: "set #on=:value"
			});
			resolve();
		} catch (err) {
			console.error(err);
			reject(err);
		}
	});
};

export const updateBanner = async banner => {
	try {
		const response = await request({
			reqId: "0a781917-4959-4da0-901e-c555078aad80",
			datatype: "mode",
			id: "banner_setting",
			names: {
				"#banner": "banner"
			},
			values: {
				":value": banner
			},
			update: "set #banner=:value"
		});
		return response;
	} catch (err) {
		console.error(err);
	}
};
